import React from "react";

/**
 * Thin geometric line icons (brief §14) — drafting-symbol style,
 * 1.5px stroke, currentColor, no icon-library dependency.
 */
const base = {
  width: 28,
  height: 28,
  viewBox: "0 0 28 28",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  "aria-hidden": true,
  focusable: "false",
};

/* AI Products → cube / neural geometry */
export const IconCube = () => (
  <svg {...base}>
    <path d="M14 3l9 5v12l-9 5-9-5V8l9-5z" />
    <path d="M14 3v10M14 13l9-5M14 13l-9-5M14 13v12" opacity="0.6" />
  </svg>
);

/* Optimization → dial / gauge */
export const IconDial = () => (
  <svg {...base}>
    <circle cx="14" cy="14" r="10" />
    <path d="M14 14l5.5-5.5" />
    <path d="M14 24v-2M24 14h-2M4 14h2M7 7l1.4 1.4M21 7l-1.4 1.4" opacity="0.6" />
  </svg>
);

/* Strategy → branching circuit / tree */
export const IconBranch = () => (
  <svg {...base}>
    <path d="M14 25V13M14 13L7 6M14 13l7-7" />
    <circle cx="7" cy="4.5" r="1.8" />
    <circle cx="21" cy="4.5" r="1.8" />
    <circle cx="14" cy="25" r="1.8" />
    <path d="M7 6.3V10M21 6.3V10" opacity="0.6" />
  </svg>
);

/* Readiness → shield */
export const IconShield = () => (
  <svg {...base}>
    <path d="M14 3l9 3.5V13c0 6-3.8 9.6-9 12-5.2-2.4-9-6-9-12V6.5L14 3z" />
    <path d="M10 13.5l3 3 5.5-5.5" opacity="0.7" />
  </svg>
);

/* Training → classical column */
export const IconColumn = () => (
  <svg {...base}>
    <path d="M5 6h18M5 22h18M7 25h14M7 3h14" />
    <path d="M9 6v16M14 6v16M19 6v16" opacity="0.6" />
  </svg>
);
